import { Skeleton } from "antd"
import React, { Suspense, lazy, useCallback, useState } from "react"

import type { PermissionsBlockingUsersResponse } from "./redux/permissions.types.ts"

const BlockingUsersModal = lazy(
  () => import("./components/BlockingUsersModal.tsx")
)

interface BlockingError {
  blocking: PermissionsBlockingUsersResponse
}

export const isBlockingError = (e: unknown): e is BlockingError =>
  typeof e === "object" &&
  e !== null &&
  "blocking" in e &&
  !!(e as { blocking?: unknown }).blocking

interface ProcessState {
  blocking: PermissionsBlockingUsersResponse
  resolve: (resolved: boolean) => void
}

export function useProcessPermissions() {
  const [state, setState] = useState<ProcessState | null>(null)

  const processPermissions = useCallback(
    (blocking: PermissionsBlockingUsersResponse) =>
      new Promise<boolean>((resolve) => {
        setState({ blocking, resolve })
      }),
    []
  )

  const close = (resolved: boolean) => {
    setState((curr) => {
      curr?.resolve(resolved)
      return null
    })
  }

  const modalNode = state ? (
    <Suspense
      fallback={
        <Skeleton.Node
          active
          className={"fixed z-50 inset-x-0 top-40 m-auto size-[50vw] h-[30vh]"}
        />
      }
    >
      <BlockingUsersModal
        blocking={state?.blocking}
        onClose={() => close(false)}
        onResolved={() => close(true)}
      />
    </Suspense>
  ) : null

  return { processPermissions, modalNode }
}
